import { useCallback } from 'react';
import { integrationsApi } from 'apis/integrations';
import { queuesApi } from 'apis/queues';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { createEmailPayload } from './helper';
/** A hook that handles creating a new email. */
export const useCreateEmail = () => {
    const dispatch = useAppDispatch();
    const defaultQueue = useAppSelector(({ settings }) => settings.organization.organization.default_queue);
    const createEmail = useCallback((payload) => {
        const emailPayload = createEmailPayload(payload);
        return Promise.all([
            dispatch(integrationsApi.endpoints.createEmailIntegration.initiate(emailPayload)),
            dispatch(queuesApi.endpoints.readQueue.initiate({ id: defaultQueue })),
        ]);
    }, [defaultQueue, dispatch]);
    return createEmail;
};
